import { useQuery } from "react-query";
import { getCurrencyList } from "../services/getCurrencyList";

function useGetCurrencyList(token: string) {
  return useQuery({
    queryKey: ["getCurrencyList"],
    queryFn: () => getCurrencyList(token),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetCurrencyList;
